/* eslint-disable */
import {
  mdiViewDashboard,
  mdiAccountAlert,
  mdiBusDoubleDecker,
  mdiAccountArrowLeft,
  mdiAccountArrowLeftOutline,
  mdiFaceAgent,
  mdiAccountCircle,
  mdiAccountGroup,
  mdiSchool,
  mdiBookOpenVariant,
  mdiBookshelf,
  mdiBookOpenPageVariant,
  mdiBookPlusMultiple,
  mdiHammerScrewdriver,
  mdiFormatListBulletedType,
  mdiFormatLetterMatches,
  mdiNumeric9BoxMultiple,
  mdiNotebookEdit,
  mdiAccountDetails,
  mdiTimetable,
  mdiCalendarMonth,
  mdiTimelineClockOutline,
  mdiPuzzle,
  mdiConsoleNetworkOutline,
  mdiSoccer,
  mdiClipboardAccount,
  mdiClipboardAccountOutline,
  mdiQrcodeScan,
  mdiRunFast,
  mdiTrophyOutline
} from "@mdi/js";
// const roles = localStorage.getItem('roles')
const menuConsellor = [
  {
    to: "/comboard-dashboard",
    icon: mdiViewDashboard,
    label: "sidebar.dashboard",
  },
  {
    label: "sidebarFin.students",
    subLabel: "Submenus Student",
    icon: mdiAccountCircle,
    menu: [
      {
        to: "/students",
        label: "sidebarFin.students",
        icon: mdiAccountGroup,
      },
      {
        to: '/non-academic-activity',
        label: 'sidebarFin.nonAcademicActivity',
        icon: mdiRunFast
      },
      {
        to: '/student-achievement',
        label: 'sidebarFin.studentAchievement',
        icon: mdiTrophyOutline
      }
    ],
  },
  {
    label: "sidebarFin.permissionRequest",
    subLabel: "Submenus Teacher",
    icon: mdiFaceAgent,
    menu: [
      {
        to: "/permissions",
        label: "sidebarTeacher.permission",
        icon: mdiFaceAgent,
      },
      {
        to: "/permission-reason",
        label: "sidebarTeacher.permissionReason",
        icon: mdiFaceAgent,
      },
    ],
  },
  {
    label: "sidebarFin.attendance",
    subLabel: "Submenus Attendance",
    icon: mdiAccountArrowLeft,
    menu: [
      {
        to: "/daily-attendance",
        label: "sidebarFin.dailyAttendance",
        icon: mdiConsoleNetworkOutline,
      },
      {
        to: "/regular-subject-attendance",
        label: "sidebarFin.regularSubject",
        icon: mdiAccountArrowLeftOutline,
      },
      {
        to: "/parallel-subject",
        label: "sidebarFin.parallelSubject",
        icon: mdiAccountArrowLeftOutline,
      },
      {
        to: "/report-attendance-daily",
        label: "sidebarFin.dailyAttendanceReport",
        icon: mdiAccountAlert,
      },
      {
        to: "/assignment-special",
        label: "sidebarFin.specialAssignment",
        icon: mdiBusDoubleDecker,
      },
    ],
  },
  {
    label: "sidebarFin.schedule",
    subLabel: "Submenus Schedule",
    icon: mdiTimetable,
    menu: [
      // 	{
      // 	to: '/schooltime',
      // 	label: 'School Time',
      // 	icon: mdiAvTimer
      // },
      // {
      // 	to: '/studytime',
      // 	label: 'Study Time',
      // 	icon: mdiAvTimer
      // },
      {
        to: "/schedule",
        label: "sidebarFin.schedule",
        icon: mdiTimetable,
      },
      {
        to: "/extracuricular-schedule",
        label: "sidebarFin.extracuricularSchedule",
        icon: mdiTimetable,
      },
      {
        to: "/calendar",
        label: "sidebarFin.calendar",
        icon: mdiCalendarMonth,
      },
    ],
  },

  {
    label: "sidebarFin.extracurricular",
    subLabel: "Submenus Extracuricular",
    icon: mdiSoccer,
    menu: [
      {
        to: "/extracuricular",
        label: "sidebarFin.extracurricular",
        icon: mdiSoccer,
      },
      {
        to: "/extracuricular-group",
        label: "sidebarFin.extracurricularGroup",
        icon: mdiSoccer,
      },
      {
        to: "/extracuricular-student",
        label: "sidebarFin.extracurricularStudent",
        icon: mdiAccountDetails,
      },
      {
        to: "/extracuricular-student-select",
        label: "sidebarFin.extracurricularStudentSelect",
        icon: mdiAccountDetails,
      },
      // {
      // 	to: '/extracuricularbarchart',
      // 	label: 'Report Extracuricular',
      // 	icon: mdiAccountDetails
      // }
    ],
  },
  {
    label: "sidebarFin.teacher",
    subLabel: "Submenus Teacher",
    icon: mdiClipboardAccount,
    menu: [
      {
        to: "/teacher",
        label: "sidebarFin.teacher",
        icon: mdiClipboardAccountOutline,
      },
      {
        to: "/teacher-extracuricular",
        label: "sidebarFin.extracurricularTeacher",
        icon: mdiSoccer,
      },
      {
        to: "/teacher-note",
        label: "sidebarFin.teacherNote",
        icon: mdiAccountDetails,
      },
      // {
      // 	to: '/teacherjournal',
      // 	label: 'Teacher Journal',
      // 	icon: mdiFileDocument
      // }
    ],
  },
];
export default menuConsellor;
